import { alpha, Box, Chip } from '@mui/material';
import { colors } from 'lib/designSystem/Table/cellFormat';
import { BASE_COLORS } from 'lib/functions/const/colors';
import React from 'react';

export const statusColor = (name: string, severity?: number): string => {
  if (colors[name]) return colors[name];

  if (severity !== undefined) {
    if (severity === 0) return BASE_COLORS.green;
    if (severity === 1) return BASE_COLORS.orange;
    if (severity === 2) return BASE_COLORS.orange;
    if (severity >= 3) return BASE_COLORS.red;
  }

  const lower = name.toLowerCase();
  if (lower.includes('aprobado') || lower.includes('aprobada'))
    return BASE_COLORS.green;
  if (lower.includes('rechazado') || lower.includes('rechazada'))
    return BASE_COLORS.red;
  if (lower.includes('advertencia')) return BASE_COLORS.orange;
  if (lower.includes('comit')) return BASE_COLORS.orange;
  if (lower.includes('pendiente') || lower.includes('espera'))
    return BASE_COLORS.yellow;

  return BASE_COLORS.gray;
};

export const PulsingDot: React.FC<{ delay?: number }> = ({ delay = 0 }) => (
  <Box
    sx={{
      width: 9,
      height: 9,
      mx: 2,
      borderRadius: '50%',
      backgroundColor: BASE_COLORS.amber,
      flexShrink: 0,
      '@keyframes blink': {
        '0%, 100%': { opacity: 1 },
        '50%': { opacity: 0.15 },
      },
      animation: `blink 1.4s ease-in-out ${delay}s infinite`,
    }}
  />
);

interface StatusChipProps {
  label: string;
  severity?: number;
}

export const StatusChip: React.FC<StatusChipProps> = ({ label, severity }) => {
  const color = statusColor(label, severity);
  return (
    <Chip
      label={label}
      size="small"
      style={{
        backgroundColor: alpha(color, 0.15),
        color: color,
        fontWeight: 'bold',
        fontSize: '12px',
        height: 22,
        opacity: 1,
      }}
    />
  );
};
